import { Box, Button } from "@chakra-ui/react";
import {
  VStack,
  colors,
  Spacing,
  GOI_PLATFORM_URL,
  customEvent,
} from "goi_common";
import { useRouter } from "next/router";

import HomeV4ReviewCard from "./HomeV4ReviewCard";

const NINE_NINE_ZERO_REVIEWS = [
  {
    id: 1524,
    url: "https://www.goifuneral.co.kr/review/1524/",
    author: "서OO 님의 후기",
    date: "2026년 1월 7일",
    content: (
      <>
        너무 극진히 엄마를 모셔주셨다며 함께 참석했던 모든 친척 어르신들께서
        감동을 받으셨고,{" "}
        <b className="subtitle_16_sb">
          &quot;정말 잘한다&quot;는 칭찬이 끊이지 않았습니다.
        </b>
      </>
    ),
  },
  {
    id: 1453,
    url: "https://www.goifuneral.co.kr/review/1453/",
    author: "황OO 님의 후기",
    date: "2025년 12월 17일",
    content: (
      <>
        진행 내내 추가금에 대한 부담이나 불필요한 권유도 없고{" "}
        <b className="subtitle_16_sb">
          고인을 위한 마음으로 처음 안내받은 그대로 투명하게 진행되었습니다.
        </b>
      </>
    ),
  },
  {
    id: 1447,
    url: "https://www.goifuneral.co.kr/review/1447/",
    author: "송OO 님의 후기",
    date: "2025년 12월 14일",
    content: (
      <>
        저는 상조 회사는 다 똑같은 줄 알았습니다.{" "}
        <b className="subtitle_16_sb">
          우리나라에도 이런 상조회사 이런 장례지도사가 있다는 걸 처음
          알았습니다.
        </b>
      </>
    ),
  },
];

export default function HomeV4ReviewSection() {
  const router = useRouter();

  return (
    <VStack
      margin="80px 0px 0px"
      padding="56px 20px"
      background={colors.gray50}
    >
      <Box className="subtitle_16_r" color={colors.gray600}>
        꾸밈없이 작성된 그대로
      </Box>
      <Spacing gap={8} />

      <Box className="subtitle_21_sb" color={colors.gray900}>
        고이 상조, 실 이용자 후기 공개합니다
      </Box>
      <Spacing gap={24} />

      <VStack gap={16}>
        {NINE_NINE_ZERO_REVIEWS.map((review) => (
          <>
            <HomeV4ReviewCard
              key={review.id}
              rating={5}
              author={review.author}
              date={review.date}
              content={review.content}
              background={colors.white}
              onClick={() => {
                router.push(review.url);
              }}
            />
          </>
        ))}
      </VStack>

      <Spacing gap={24} />
      <Button
        className="body_16_m"
        background={colors.white}
        color={colors.gray900}
        height="48px"
        onClick={() => {
          customEvent({
            newGtm: {
              path: "home",
              trigger_and_target: "CTA-uv_review",
            },
          });
          router.push(`${GOI_PLATFORM_URL}/review/`);
        }}
      >
        더 많은 후기 확인하기
      </Button>
    </VStack>
  );
}
